export default __webpack_public_path__ + "static/media/skill development-08.199588fb.png";